import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'VISUAL INSTRUCTIONS.', 'STRUCTURED LESSONS.', 'PROFESSIONAL REFERENCE MATERIAL.', 'PRACTICAL INSTRUCTOR TOOLS.', 'CLEAR TRAINING PROGRESSIONS.', 'BETTER PREPARATION.'];
const alreadyHave = ['You already have the firefighter equipment references.', 'You already have the hose and water supply diagrams.', 'You already have the building access illustrations.', 'You already have the search and rescue training maps.', 'You already have the technical incident references.', 'You already have the instructor training frameworks.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-neutral-200" data-id="element-56" data-mp="13oe23q38lxgt">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-57" data-mp="214kt9i4s2iyr">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-neutral-900 mb-6 uppercase" data-id="element-58" data-mp="24xz0exmolyma">
          You Don&apos;t Need More Random Firefighter Training Material.
        </h2>
        <p className="text-xl text-neutral-800/80 mb-5" data-id="element-59" data-mp="1v3p63ae6iq8x">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-60" data-mp="203l9b7f1ydnf">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-red-700 tracking-wide" data-id="element-61" data-mp="1l6aov8kflxfk">
              {need}
            </li>)}
        </ul>
        <div className="bg-neutral-100 border border-neutral-200 rounded-2xl p-8 text-lg text-neutral-800 space-y-2 text-left sm:text-center" data-id="element-62" data-mp="1c7pdbxddnioa">
          <p className="mb-4" data-id="element-63" data-mp="1h84nkg2d4a21">
            With Fire Service Instructor Atlas, you don&apos;t start every new lesson searching
            through disconnected resources.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-neutral-900 font-semibold flex items-center sm:justify-center gap-2" data-id="element-64" data-mp="395efzi7rcxrq">
              <Check size={18} className="text-red-700 shrink-0" aria-hidden="true" data-id="element-65" data-mp="35285fydm4kfg" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-66" data-mp="306jak8cjfrph">
            And with the five professional bonuses... you also have additional resources to plan,
            challenge, assess and debrief your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-neutral-900" data-id="element-67" data-mp="3nuaothhn2ete">
            YOU ALREADY HAVE <span className="text-red-700" data-id="element-68" data-mp="3j3asadcflyrf">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}